import { initReactI18next } from 'react-i18next';

import { defaultStore } from '@stores/store';
import day from 'dayjs';
import i18n from 'i18next';
import en from 'locales/en';
import fr from 'locales/fr';

i18n.use(initReactI18next).init({
  react: {
    useSuspense: false,
  },
  lng: defaultStore.system.language,
  keySeparator: false,
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  interpolation: {
    formatSeparator: ',',
    format: function (value, formatting) {
      if (value instanceof Date) {
        return day(value).format(formatting);
      }

      try {
        return value.format(formatting);
      } catch {
        return value?.toString() || ' - ';
      }
    },
  },
});

export default i18n;
